import dataProvider from "server/dataProvider";
import { candidateRequests } from "api/candidateApi";
import { administrationRequests } from "api/administrationApi";
import { resolveErrorMessage } from "utils/useNotifyError";

export async function generateFileName(campaignExam) {
  const { data } = await dataProvider.getMany(administrationRequests.getExamsSelect(), { ids: [campaignExam.examId] });

  const examName = data?.length > 0 ? data[0].name : "exam";
  const examTimestampDate = campaignExam.examStartTimestamp ? new Date(campaignExam.examStartTimestamp) : new Date();
  const day = String(examTimestampDate.getDate()).padStart(2, "0");
  const month = String(examTimestampDate.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = examTimestampDate.getFullYear();
  const examTimestamp = `${day}${month}${year}`;

  return `${examName}${examTimestamp}`;
}

export async function importResults(event, campaignExamId, methodType, notify) {
  const file = event.target.files[0];
  if (!file) {
    return;
  }

  try {
    const response = await dataProvider.customRequest(
      candidateRequests.importCampaignExamResults(campaignExamId),
      { file: { rawFile: file } },
      methodType,
      undefined,
      true,
    );

    const { errors } = response.data;

    if (errors && errors.length > 0) {
      notify("Файлът съдържа некоректни данни!", { type: "error" });

      return errors;
    }

    notify("Файлът с оценки е качен успешно!", { type: "success" });
  } catch (error) {
    notify(resolveErrorMessage(error), { type: "error" });
  }
}
